// @flow

import { connect } from 'react-redux';

import WorkInfo from './workinfo';
import { User } from '../../../models/user';
import { workDetails, updateSearchParam, resetSearchPrams } from '../../../services/search';
import { openWorksShareholdersTab, openWorksMoreInfoTab } from '../../../services/ui';

export type Props = {
  fetching: boolean,
  authenticating: boolean,
  searchDetails: any,
  workShareList: any,
  searchParams: any,
  location: RouteComponentProps,
  user: User,
  membershipNo: string,
  headerIcon: string,
  workDetails: () => void,
  updateSearchParam: (name: string, value: string) => void,
  resetSearchPrams: () => void,
};

const mapState = ({ authentication, search, ui }) => ({
  authenticating: authentication.authenticating,
  user: authentication.user,
  fetching: search.fetching,
  searchDetails: search.searchDetails,
  tuneCode: search.searchDetails && search.searchDetails.allianceTunecode,
  searchParams: search.searchParams,
  workShareList: (search.searchDetails && search.searchDetails.finalShareHolders &&
    search.searchDetails.finalShareHolders.workShareList) || [],
  shareholdersTabOpen: ui.shareholdersTabOpen,
  moreTabOpen: ui.moreTabOpen,
});

const mapDispatch = {
  workDetails,
  updateSearchParam,
  resetSearchPrams,
  openWorksShareholdersTab,
  openWorksMoreInfoTab,
};

export default connect(
  mapState,
  mapDispatch,
)(WorkInfo);
